import { useParams } from "react-router-dom";
import { getEnv } from "../../shared/lib/env";
import { useProtectedRouteSession } from "../../shared/session/useProtectedRouteSession";
import { OperatorPageScaffold } from "../../shared/ui/protected/OperatorPageScaffold";

const pageLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/contract", label: "契約・解約" }
];

export function AdminPoliciesPage() {
  const env = getEnv();
  const { tenantSlug = "unknown-tenant" } = useParams();
  const { routeStatus, sessionStatus, session, errorMessage, isSessionReady } = useProtectedRouteSession(tenantSlug);
  const hasAdminRole = Boolean(session?.member?.roles.includes("admin"));

  return (
    <OperatorPageScaffold
      currentArea="admin"
      tenantSlug={tenantSlug}
      tenantName={session?.tenant.displayName}
      session={session}
      title="規約・ポリシー"
      description="最新の利用規約とプライバシーポリシーを確認します。"
      links={pageLinks}
    >
      <div style={{ display: "grid", gap: 16 }}>
        {routeStatus === "checking" || sessionStatus === "loading" ? <p style={{ margin: 0 }}>セッションを確認しています。</p> : null}
        {sessionStatus === "error" ? <p style={{ margin: 0 }}>セッション確認に失敗しました。{errorMessage}</p> : null}
        {routeStatus === "authenticated" && !hasAdminRole ? <p style={{ margin: 0 }}>この画面は管理者のみ利用できます。</p> : null}

        {isSessionReady && hasAdminRole ? (
          <section style={{ display: "grid", gap: 12, padding: 16, border: "1px solid #e5e7eb", borderRadius: 14 }}>
            <p style={{ margin: 0 }}>
              規約本文は外部の正本ページで管理します。アプリ内には本文を重複保持しません。
            </p>
            <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
              {env.legalTermsUrl ? (
                <a href={env.legalTermsUrl} target="_blank" rel="noopener noreferrer">利用規約を開く</a>
              ) : (
                <button type="button" disabled>利用規約は準備中</button>
              )}
              {env.legalPrivacyUrl ? (
                <a href={env.legalPrivacyUrl} target="_blank" rel="noopener noreferrer">プライバシーポリシーを開く</a>
              ) : (
                <button type="button" disabled>プライバシーポリシーは準備中</button>
              )}
            </div>
          </section>
        ) : null}
      </div>
    </OperatorPageScaffold>
  );
}
